import React, { useEffect, useState } from 'react';
import LandingPage from '../strikegames/LandingPage';
import LoginPage from './Login';
import { getEnvVariable } from '../constants/whitelabelEnv';
import { domain } from '../constants/Branding';
import LotusLandingPage from '../strikegames/LotusLandingPage';
import Strike46LovableLandingPage from '../strikegames/Strike46LovableLandingPage';

const LoginWrapper: React.FC<{ referalCode?: string }> = ({ referalCode }) => {

  const BrandName = getEnvVariable(domain, 'BRAND_NAME');


  return (
    <div className="relative w-full h-screen">
      {/* Background */}
      <div className="absolute top-0 left-0 w-full h-full z-0">
        <Strike46LovableLandingPage referalCode={referalCode} />
      </div>
      {/* Foreground - Login */}
    </div>
  );
};

export default LoginWrapper;
